import { useRef } from 'react';
import styles from './index.module.scss';

export interface FeatureMediaCardProps {
  title: string;
  description: string;
  video?: string;
}

export default function FeatureMediaCard({ title, description, video }: FeatureMediaCardProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleEnter = () => {
    const el = videoRef.current;
    if (!el) return;
    el.muted = true;
    el.defaultMuted = true;
    const play = el.play();
    if (play) play.catch(() => undefined);
  };

  const handleLeave = () => {
    const el = videoRef.current;
    if (!el) return;
    el.pause();
  };

  return (
    <article className={styles.card} onMouseEnter={handleEnter} onMouseLeave={handleLeave}>
      <div className={styles.media} aria-hidden>
        {video ? (
          <video
            ref={videoRef}
            src={video}
            muted
            loop
            playsInline
            preload="auto"
            disablePictureInPicture
            disableRemotePlayback
            controlsList="nodownload nofullscreen noremoteplayback"
          />
        ) : null}
      </div>
      <div className={styles.copy}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.desc}>{description}</p>
      </div>
    </article>
  );
}
